/* eslint-disable no-inner-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useBrandPaymentHandler } from "@/Helpers/payments/brandPayments";
import { useAuth } from "@/Providers/Auth";
import { useBrand } from "@/Providers/Brand";
import { useGeneralSettings } from "@/Providers/General";
import axios from "axios";
import React, {
  useState,
  MutableRefObject,
  ChangeEvent,
  useMemo,
  useCallback,
  createContext,
  useContext,
  useEffect,
} from "react";
import { useParams } from "react-router-dom";
import {
  initialNewCampaignFormData,
  initialNewCampaignMasterData,
  initialNewCampaignPreviewData,
  sampleInfluencers,
} from "../Helpers/Helper";
import { useToast } from "@/shadcnComponents/ui/use-toast";

import HandleValidation from "../Validations/NewCampaignFormValidator";
import {
  FormSection,
  NewCampaignFormData,
  NewCampaignFormDataState,
  NewCampaignInfluencerProfile,
  NewCampaignMasterData,
  NewCampaignPreviewData,
  NewCampaignPreviewItem,
} from "../CampaignInterface/NewCampaignInterface";
import { useDebounce } from "@/Helpers/useDebounce";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;

interface NewCampaignContextType {
  startDate: Date;
  setStartDate: React.Dispatch<React.SetStateAction<Date>>;
  endDate: Date;
  setEndDate: React.Dispatch<React.SetStateAction<Date>>;
  selectedCreators: string[];
  setSelectedCreators: React.Dispatch<React.SetStateAction<string[]>>;
  manuallyCreators: string[];
  notSelectedCreators: any[];
  setNotSelectedCreators: React.Dispatch<React.SetStateAction<any[]>>;
  setMasterData: React.Dispatch<React.SetStateAction<NewCampaignMasterData>>;
  shortlistedInfluencers: NewCampaignInfluencerProfile[];
  setShortlistedInfluencers: React.Dispatch<
    React.SetStateAction<NewCampaignInfluencerProfile[]>
  >;
  selectedPurpose: string[];
  setSelectedPurpose: React.Dispatch<React.SetStateAction<string[]>>;
  selectedContentCategory: string[];
  setSelectedContentCategory: React.Dispatch<React.SetStateAction<string[]>>;
  selectedAudienceCategory: string[];
  setSelectedAudienceCategory: React.Dispatch<React.SetStateAction<string[]>>;
  selectedGender: string[];
  setSelectedGender: React.Dispatch<React.SetStateAction<string[]>>;
  selectedCountry: string | null;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string | null>>;
  selectedState: string[] | null;
  setSelectedState: React.Dispatch<React.SetStateAction<string[] | null>>;
  selectedCities: string[] | null;
  setSelectedCities: React.Dispatch<React.SetStateAction<string[] | null>>;
  selectedAudienceLocationIds: string[];
  setSelectedAudienceLocationIds: React.Dispatch<
    React.SetStateAction<string[]>
  >;
  selectedSeniority: string[];
  setSelectedSeniority: React.Dispatch<React.SetStateAction<string[]>>;
  includedCollabCompanyNames: string[];
  setIncludedCollabCompanyNames: React.Dispatch<React.SetStateAction<string[]>>;
  excludedCollabCompanyNames: string[];
  setExcludedCollabCompanyNames: React.Dispatch<React.SetStateAction<string[]>>;

  openSelectPopup: boolean;
  setOpenSelectPopup: React.Dispatch<React.SetStateAction<boolean>>;
  openReviewPopup: boolean;
  setOpenReviewPopup: React.Dispatch<React.SetStateAction<boolean>>;
  openSuccessPage: boolean;
  setOpenSuccessPage: React.Dispatch<React.SetStateAction<boolean>>;
  openDetailsPopup: boolean;
  setOpenDetailsPopup: React.Dispatch<React.SetStateAction<boolean>>;
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  completedStep: any[];
  setCompletedStep: React.Dispatch<React.SetStateAction<any[]>>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  refreshLoading: boolean;
  setRefreshLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isReviewDone: boolean;
  setIsReviewDone: React.Dispatch<React.SetStateAction<boolean>>;
  formData: NewCampaignFormData;
  setFormData: React.Dispatch<React.SetStateAction<NewCampaignFormData>>;
  previewData: NewCampaignPreviewData;
  setPreviewData: React.Dispatch<React.SetStateAction<NewCampaignPreviewData>>;
  masterData: NewCampaignMasterData;
  collabFactors: any;
  currentPreviewList: NewCampaignPreviewItem[];
  setCurrentPreviewList: React.Dispatch<
    React.SetStateAction<NewCampaignPreviewItem[]>
  >;
  searchCreatorInput: any;
  setSearchCreatorInput: React.Dispatch<React.SetStateAction<any>>;
  manuallySearchCreators: any[];
  openCheckOutPopup: boolean;
  setOpenCheckOutPopup: React.Dispatch<React.SetStateAction<boolean>>;
  manualSearch: string;
  sampleCampaign: boolean;
  setSampleCampaign: React.Dispatch<React.SetStateAction<boolean>>;
  setCollabFactors: React.Dispatch<any>;
  setAllCredits: React.Dispatch<
    React.SetStateAction<{
      collaborationCredits: number;
      anchorsCredits: number;
      campaignCredits: number;
    }>
  >;
  setCollabCharges: React.Dispatch<React.SetStateAction<number>>;
  setCampaignCharges: React.Dispatch<React.SetStateAction<number>>;
  stepValidations: {
    1: () => Date;
    2: () => number;
    3: () => boolean;
    4: () => boolean;
    5: () => boolean;
    6: () => boolean;
  };
  collabId: string;
  setManuallyCreators: React.Dispatch<React.SetStateAction<string[]>>;

  //payment
  paymentProcessing: boolean;
  setPaymentProcessing: React.Dispatch<React.SetStateAction<boolean>>;
  selectedPaymentFormat: string;
  setSelectedPaymentFormat: React.Dispatch<React.SetStateAction<string>>;
  selectedPaymentMethod: "card" | "upi";
  setSelectedPaymentMethod: React.Dispatch<
    React.SetStateAction<"card" | "upi">
  >;
  usedAnchorsCredits: number;
  usedCollaborationCredits: number;
  setUsedAnchorsCredits: React.Dispatch<React.SetStateAction<number>>;
  setUsedCollaborationCredits: React.Dispatch<React.SetStateAction<number>>;
  usedCampaignAddOn: number;
  setUsedCampaignAddOn: React.Dispatch<React.SetStateAction<number>>;
  AllCredits: {
    collaborationCredits: number;
    anchorsCredits: number;
    campaignCredits: number;
  };
  collaborationCharges: number;
  campaignCharges: number;

  //filters
  openTryManualFilter: boolean;
  setOpenTryManualFilter: React.Dispatch<React.SetStateAction<boolean>>;
  selectedEngageMentRate: any[];
  setSelectedEngageMentRate: React.Dispatch<React.SetStateAction<any[]>>;
  selectedSuperRoles: any[];
  setSelectedSuperRoles: React.Dispatch<React.SetStateAction<any[]>>;
  selectedUniqueBadge: any[];
  setSelectedUniqueBadge: React.Dispatch<React.SetStateAction<any[]>>;
  selectedAverageLikes: any[];
  setSelectedAverageLikes: React.Dispatch<React.SetStateAction<any[]>>;
  selectedYearsOfExperiance: any[];
  setSelectedYearsOfExperiance: React.Dispatch<React.SetStateAction<any[]>>;
  selectedCompanyTier: string[];
  setSelectedCompanyTier: React.Dispatch<React.SetStateAction<string[]>>;

  //coupon
  allowCoupons: string;
  coupon: string;
  adminFeature: string;
  setCoupon: React.Dispatch<React.SetStateAction<string>>;
  appliedCoup: boolean;
  setAppliedCoup: React.Dispatch<React.SetStateAction<boolean>>;
  originalPriceBeforeCoupon: number;
  setOriginalPriceBeforeCoupon: React.Dispatch<React.SetStateAction<number>>;
  onCouponSubmit: () => void;

  formValidation: ({ checkArray }: { checkArray?: number[] }) => boolean;
  handleSaveData: ({
    isAddMore,
    isRefresh,
  }: {
    isAddMore?: boolean;
    isRefresh?: boolean;
  }) => Promise<{
    success: boolean;
    data: any;
  }>;
  handleNext: () => Promise<void>;
  handlePrevious: () => void;
  handleInputChange: (
    e: ChangeEvent<HTMLInputElement>,
    section: FormSection,
    field: string
  ) => void;
  handleFileChange: (
    e: ChangeEvent<HTMLInputElement>,
    section: FormSection,
    field: string
  ) => void;
  removeImage: (index: number, section: FormSection, field: string) => void;
  saveProductImages: () => Promise<NewCampaignFormData>;
  handleBudgetChange: (
    value: number,
    field: "minBillAmount" | "maxBillAmount"
  ) => void;
  handleDraftChange: (
    field: string,
    value: string | File[] | number,
    index: number
  ) => void;
  handleSelectChange: (
    field: string,
    section: FormSection,
    value: string
  ) => void;
  handleSelectCreator: (value: any, shortlistedType: any) => Promise<void>;
  handleIgnoreCreator: (value: any, shortlistedType: any) => Promise<void>;
  handleSelectManualCreator: (value: any) => void;
  handlePayment: () => Promise<void>;
  handleSearchCreator: (e: any) => Promise<void>;
}

export const NewCampaignContext = createContext<
  NewCampaignContextType | undefined
>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const useNewCampaign = () => {
  const context = useContext(NewCampaignContext);
  if (context === undefined) {
    throw new Error(
      "useNewCampaign must be used within an NewCampaignProvider"
    );
  }
  return context;
};

export const NewCampaignProvider: React.FC<{
  children: React.ReactNode;
  effectRan?: MutableRefObject<boolean>;
}> = ({ children }) => {
  const { toast } = useToast();
  const { collabId } = useParams();
  const brandState = useBrand();
  const authState = useAuth();
  const { handlePaymentClick, handleCouponCodeSubmit } =
    useBrandPaymentHandler();
  const generalState = useGeneralSettings();
  const query = new URLSearchParams(window.location.search);
  const variant = query?.get("variant");
  const manualSearch = query?.get("manualSearch");
  const allowCoupons = query?.get("allowCoupons");
  const adminFeature = query?.get("adminFeature");
  const [sampleCampaign, setSampleCampaign] = useState<boolean>(false);

  //useStates
  const [paymentProcessing, setPaymentProcessing] = useState(false);

  const [selectedCreators, setSelectedCreators] = useState<string[]>([]);
  const [manuallyCreators, setManuallyCreators] = useState<string[]>([]);
  const [notSelectedCreators, setNotSelectedCreators] = useState([]);
  const [shortlistedInfluencers, setShortlistedInfluencers] = useState<
    NewCampaignInfluencerProfile[]
  >([]);
  const [manuallySearchCreators, setManuallySearchCreators] = useState([]);

  const [currentStep, setCurrentStep] = useState(null);
  const [completedStep, setCompletedStep] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [isReviewDone, setIsReviewDone] = useState(false);
  const [searchCreatorInput, setSearchCreatorInput] = useState(null);

  //popup states
  const [openSelectPopup, setOpenSelectPopup] = useState(false);
  const [openCheckOutPopup, setOpenCheckOutPopup] = useState(false);
  const [openReviewPopup, setOpenReviewPopup] = useState(false);
  const [openSuccessPage, setOpenSuccessPage] = useState(false);
  const [openDetailsPopup, setOpenDetailsPopup] = useState(false);

  //coupon states
  const [originalPriceBeforeCoupon, setOriginalPriceBeforeCoupon] = useState(0);
  const [coupon, setCoupon] = useState("");
  const [appliedCoup, setAppliedCoup] = useState(false);

  //filters State
  const [openTryManualFilter, setOpenTryManualFilter] = useState(false);
  const [selectedEngageMentRate, setSelectedEngageMentRate] = useState([]);
  const [selectedSuperRoles, setSelectedSuperRoles] = useState([]);
  const [selectedUniqueBadge, setSelectedUniqueBadge] = useState([]);
  const [selectedAverageLikes, setSelectedAverageLikes] = useState([]);
  const [selectedYearsOfExperiance, setSelectedYearsOfExperiance] = useState(
    []
  );
  const [selectedCompanyTier, setSelectedCompanyTier] = useState<string[]>([]);
  const [selectedPurpose, setSelectedPurpose] = useState<string[]>([]);
  const [selectedContentCategory, setSelectedContentCategory] = useState<
    string[]
  >([]);
  const [selectedAudienceCategory, setSelectedAudienceCategory] = useState<
    string[]
  >([]);
  const [selectedGender, setSelectedGender] = useState<string[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [selectedState, setSelectedState] = useState<string[] | null>([]);
  const [selectedCities, setSelectedCities] = useState<string[]>([]);
  const [selectedAudienceLocationIds, setSelectedAudienceLocationIds] =
    useState<string[]>([]);
  const [selectedSeniority, setSelectedSeniority] = useState<string[]>([]);
  const [includedCollabCompanyNames, setIncludedCollabCompanyNames] = useState<
    string[]
  >([]);
  const [excludedCollabCompanyNames, setExcludedCollabCompanyNames] = useState<
    string[]
  >([]);

  //form states
  // eslint-disable-next-line prefer-const
  let [formData, setFormData]: NewCampaignFormDataState =
    useState<NewCampaignFormData>(initialNewCampaignFormData);
  const [startDate, setStartDate] = React.useState<Date>();
  const [endDate, setEndDate] = React.useState<Date>();

  //Data states
  const [previewData, setPreviewData] = useState<NewCampaignPreviewData>(
    initialNewCampaignPreviewData
  );
  const [masterData, setMasterData] = useState<NewCampaignMasterData>(
    initialNewCampaignMasterData
  );
  const [collabFactors, setCollabFactors] = useState(null);
  const [currentPreviewList, setCurrentPreviewList] = useState<
    NewCampaignPreviewItem[]
  >([]);

  //payment states
  const [selectedPaymentFormat, setSelectedPaymentFormat] =
    useState<string>("full");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    "card" | "upi" | null
  >(null);
  const [AllCredits, setAllCredits] = useState({
    collaborationCredits: 0,
    anchorsCredits: 0,
    campaignCredits: 0,
  });
  const [usedCollaborationCredits, setUsedCollaborationCredits] = useState(0);
  const [usedAnchorsCredits, setUsedAnchorsCredits] = useState(0);
  const [usedCampaignAddOn, setUsedCampaignAddOn] = useState(0);
  const [collaborationCharges, setCollabCharges] = useState(0);
  const [campaignCharges, setCampaignCharges] = useState(0);

  //controllers

  const stepValidations = useMemo(
    () => ({
      1: () => {
        const { collabInfo, Budget } = formData;
        return (
          collabInfo?.collabPurpose?.length &&
          collabInfo?.collabGoals?.length &&
          collabInfo?.collabPlatform?.length &&
          collabInfo?.collabIndustry?.length &&
          collabInfo?.collabBuisnessType?.length &&
          parseInt(Budget?.maxBillAmount?.toString()) > 0 &&
          parseInt(Budget?.minBillAmount?.toString()) > 0 &&
          startDate &&
          endDate
        );
      },
      2: () => {
        const { creatorInfo, postInfo } = formData;
        return (
          creatorInfo?.minCreatorFollowers?.length &&
          creatorInfo?.maxCreatorFollowers?.length &&
          postInfo?.postDrafts?.filter((i) => i?.status)?.[0]?.postFormat
            ?.length
        );
      },
      3: () => selectedCreators?.length > 0,
      4: () => {
        const { productInfo, postInfo } = formData;
        return (
          productInfo?.productName?.length &&
          postInfo?.postDrafts
            ?.filter((i) => i?.status)
            ?.every(
              (draft) =>
                draft.postDescription?.length &&
                draft.postGuidelines?.length &&
                draft?.assignedInfluencers?.length &&
                draft?.postFormat?.length
            )
        );
      },
      5: () => isReviewDone,
      6: () => openSuccessPage,
    }),
    [
      formData,
      selectedCreators,
      startDate,
      endDate,
      isReviewDone,
      openSuccessPage,
    ]
  );
  const formValidation = ({ checkArray }: { checkArray?: number[] }) => {
    const validationResult = HandleValidation({
      formData,
      currentStep,
      checkArray,
      selectedPurpose,
      startDate,
      endDate,
      toast,
      setCurrentStep,
      setIsLoading,
      generalState,
      SelectedInfluencersWithCPI: previewData?.SelectedInfluencersWithCPI,
    });

    return validationResult;
  };

  const handleSaveData = async ({
    isAddMore,
    isRefresh,
  }: {
    isAddMore?: boolean;
    isRefresh?: boolean;
  }) => {
    formData = await saveProductImages();
    try {
      if (collabId === "sample") {
        // for testing purpose, simulate a successful save
        setShortlistedInfluencers(sampleInfluencers);
        setPreviewData((prev) => {
          return {
            ...prev,
            numberOfInfluencers: 4,
            minImpressions: 81868,
            maxImpressions: 91499,
            ExpectedSpendAmount: 37074,
            ExpectedFinalMaxImpression: 81868,
            ExpectedFinalMinImpression: 91499,
            ExpectedAllImpressionAmount: 37074,
            SelectedInfluencersWithCPI: sampleInfluencers,
          };
        });
        return { success: true, data: {} };
      }

      const res = await axios.post(
        `${host}/collabs/brand/createBrandCollabs`,
        {
          collabId: collabId,
          step: currentStep,
          data: {
            campaignInfo: {
              ...formData?.campaignInfo,
              campaignStartDate: startDate,
              campaignEndDate: endDate,
            },
            collabInfo: formData?.collabInfo,
            creatorInfo: {
              contentCategory: formData?.creatorInfo?.contentCategory,
              audienceCategory: formData?.creatorInfo?.audienceCategory,
              followers:
                formData.creatorInfo.maxCreatorFollowers === "More than 100k"
                  ? [
                      `${formData.creatorInfo.minCreatorFollowers}-${"100k"}`,
                      "More than 100k",
                    ]
                  : [
                      `${formData.creatorInfo.minCreatorFollowers}-${formData.creatorInfo.maxCreatorFollowers}`,
                    ],
              isPastCollabs: formData.creatorInfo.isPastCollabs,
              gender: selectedGender,
              seniority: selectedSeniority,

              //manual filters
              avgEngageMentRate: selectedEngageMentRate,
              superRoles: selectedSuperRoles,
              badge: selectedUniqueBadge,
              avgLikes: selectedAverageLikes,
              yearsOfExperience: selectedYearsOfExperiance,
              companyLevel: selectedCompanyTier,
              SelectedAudienceLocation:
                selectedState?.length > 0 ? selectedAudienceLocationIds : [],
              includedCollabCompanyNames,
              excludedCollabCompanyNames,
            },
            productInfo: formData?.productInfo,
            postInfo: formData?.postInfo,
            Budget: formData?.Budget,
          },
          isAddMore: isAddMore,
          isRefresh: isRefresh,
          sampleCampaign: sampleCampaign,
          notSelectedCreators: notSelectedCreators?.map((item) => item?._id),
          ignoreBudget:
            openTryManualFilter &&
            (selectedEngageMentRate?.length ||
              selectedSuperRoles?.length ||
              selectedUniqueBadge?.length ||
              selectedAverageLikes?.length ||
              selectedYearsOfExperiance?.length ||
              selectedCompanyTier?.length ||
              formData?.creatorInfo?.minCreatorFollowers ||
              formData?.creatorInfo?.maxCreatorFollowers),
          variant: variant,
          shortlistedType: openTryManualFilter ? "Manual" : "AI",
        },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (res?.status === 200 && res?.data?.success) {
        generalState?.setLoading(false);
        if (isRefresh) {
          setShortlistedInfluencers(res?.data?.shortlistedInfluencers);
        }
        setPreviewData((prev) => {
          return {
            ...prev,
            numberOfInfluencers: isRefresh
              ? res?.data?.shortlistedInfluencers?.length
              : previewData?.numberOfInfluencers,
            minImpressions: res?.data?.minImpression,
            maxImpressions: res?.data?.maxImpression,
            ExpectedSpendAmount:
              currentStep > 2 ? res?.data?.ExpectedSpendAmount : 0,
            ExpectedFinalMinImpression:
              currentStep > 2 ? res?.data?.ExpectedFinalMinImpression : 0,
            ExpectedFinalMaxImpression:
              currentStep > 2 ? res?.data?.ExpectedFinalMaxImpression : 0,
            ExpectedAllImpressionAmount: res?.data?.ExpectedAllImpressionAmount,
            SelectedInfluencersWithCPI: res?.data?.SelectedInfluencersWithCPI,
          };
        });
        return { success: true, data: res?.data };
      } else {
        generalState?.setLoading(false);
        return { success: false, data: res?.data };
      }
    } catch (error) {
      generalState?.setLoading(false);
      return { success: false, data: error };
    } finally {
      generalState?.setLoading(false);
    }
  };
  const handleNext = async () => {
    // generalState?.setLoading(true);
    setIsLoading(true);
    if (formValidation({})) {
      const isDataSaved = await handleSaveData({ isAddMore: false });
      if (isDataSaved?.success) {
        if (currentStep !== 2) {
          setIsLoading(false);
        }
        setCurrentStep(currentStep + 1);
      } else {
        setIsLoading(false);
        toast({
          title: "Failed to save data",
          variant: "destructive",
        });
      }
    }
  };
  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleFileChange = (
    e: ChangeEvent<HTMLInputElement>,
    section: FormSection,
    field: string
  ) => {
    const files = Array.from(e.target.files);
    setFormData({
      ...formData,
      [section]: {
        ...formData[section],
        [field]: [...formData[section][field], ...files],
      },
    });
  };
  const removeImage = (index: number, section: FormSection, field: string) => {
    setFormData({
      ...formData,
      [section]: {
        ...formData[section],
        [field]: formData[section][field].filter(
          (_, fileIndex) => fileIndex !== index
        ),
      },
    });
  };
  const saveProductImages = async () => {
    const data = formData;
    data.postInfo.postDrafts = await Promise.all(
      data?.postInfo?.postDrafts?.map(async (draft) => {
        if (draft?.postImage?.length > 0) {
          const updatedImages = await Promise.all(
            draft.postImage.map(async (image) => {
              if (image instanceof Blob) {
                const formData = new FormData();
                formData.append("file", image);
                const result = await brandState?.uploadBrandCollabImage(
                  formData
                );
                return result?.success ? result?.result?.Location : image;
              }
              return image;
            })
          );
          return { ...draft, postImage: updatedImages };
        }
        if (
          draft?.postFormat?.toLowerCase().includes("carousel") &&
          draft?.postPdf?.length > 0
        ) {
          const updatedPdfs = await Promise.all(
            draft.postPdf.map(async (pdf) => {
              if (pdf instanceof Blob) {
                const formData = new FormData();
                formData.append("file", pdf);
                const result = await brandState?.uploadBrandCollabImage(
                  formData
                );
                return result?.success ? result?.result?.Location : pdf;
              }
              return pdf;
            })
          );
          return { ...draft, postPdf: updatedPdfs };
        }
        return draft;
      })
    );

    if (data?.productInfo?.productImage?.length > 0) {
      data.productInfo.productImage = await Promise.all(
        data.productInfo.productImage.map(async (image) => {
          if (image instanceof Blob) {
            const formData = new FormData();
            formData.append("file", image);
            const result = await brandState?.uploadBrandCollabImage(formData);
            return result?.success ? result?.result?.Location : image;
          }
          return image;
        })
      );
    }

    return data;
  };
  const handleFormChange = (
    section: FormSection,
    field: string,
    value: string | number | boolean
  ) => {
    setFormData((prev) => {
      // Special handling for budget
      if (section === "Budget") {
        const numValue = Number(value);
        const validValue = numValue < 0 ? 0 : numValue;

        return {
          ...prev,
          Budget: {
            ...prev.Budget,
            [field]: validValue,
          },
        };
      }

      // Normal field updates
      return {
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      };
    });
  };

  const handleSelectChange = (
    field: string,
    section: FormSection,
    value: string
  ) => {
    handleFormChange(section, field, value);
  };
  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement>,
    section: FormSection,
    field: string
  ) => {
    handleFormChange(section, field, e.target.value);
  };
  const handleBudgetChange = (
    value: number,
    field: "minBillAmount" | "maxBillAmount"
  ) => {
    handleFormChange("Budget", field, value);
  };
  const handleDraftChange = (
    field: string,
    value: string | File[] | number,
    index: number
  ) => {
    setFormData({
      ...formData,
      postInfo: {
        ...formData.postInfo,
        postDrafts: formData?.postInfo?.postDrafts?.map((draft, draftIndex) => {
          if (draft.status === 0) {
            index += 1;
          }
          if (draftIndex === index && draft.status !== 0) {
            return {
              ...draft,
              [field]:
                field === "assignedInfluencers"
                  ? Array.isArray(value)
                    ? value
                    : [value]
                  : value,
            };
          }
          return draft;
        }),
      },
    });
  };

  const handleSelectCreator = useCallback(
    async (value: NewCampaignInfluencerProfile, shortlistedType) => {
      const toggleData = {
        collabId,
        influencerId: value?._id,
        shortlistedType,
        selectionStage: "initial",
        action: {
          type: "",
          time: new Date(),
        },
        metrics: value?.LinkedinAnalysis,
        audienceDemographics: value?.demographicsWithPercentage,
        cleanedFollowers: value?.cleanedFollowers,
        impressionValue: value?.impressionValue,
        matchedContentCategoryLength:
          value?.matchedContentCategory?.length || 0,
        isScrapedAudiencePresent: value?.isScrapedAudiencePresent,
        matchedAudienceTypes: value?.matchedAudienceTypes?.length || 0,
        relevancyScore: value?.relevancyScore,
      };
      if (selectedCreators?.find((item) => item === value?._id)) {
        toggleData.action.type = "deselected";
        collabId !== "sample" &&
          (await brandState?.toggleInfluencer(toggleData));
        setSelectedCreators(selectedCreators.filter((i) => i !== value._id));
        toast({
          title: `${value?.name} has been deselected for campaign`,
        });
      } else {
        toggleData.action.type = "selected";
        collabId !== "sample" &&
          (await brandState?.toggleInfluencer(toggleData));
        setSelectedCreators([...selectedCreators, value._id]);
        toast({
          title: `${value?.name} is selected for campaign`,
        });
        if (!shortlistedInfluencers?.find((item) => item?._id === value._id)) {
          shortlistedInfluencers.push(value);
        }
      }
    },
    [selectedCreators, shortlistedInfluencers]
  );
  const handleIgnoreCreator = useCallback(
    async (value: NewCampaignInfluencerProfile, shortlistedType) => {
      const toggleData = {
        collabId,
        influencerId: value?._id,
        shortlistedType,
        selectionStage: "initial",
        action: {
          type: "",
          time: new Date(),
        },
        metrics: value?.LinkedinAnalysis,
        audienceDemographics: value?.demographicsWithPercentage,
        cleanedFollowers: value?.cleanedFollowers,
        impressionValue: value?.impressionValue,
        matchedContentCategoryLength:
          value?.matchedContentCategory?.length || 0,
        isScrapedAudiencePresent: value?.isScrapedAudiencePresent,
        matchedAudienceTypes: value?.matchedAudienceTypes?.length || 0,
        relevancyScore: value?.relevancyScore,
      };
      toggleData.action.type = "ignored";
      collabId !== "sample" && (await brandState?.toggleInfluencer(toggleData));
      setShortlistedInfluencers(
        shortlistedInfluencers?.filter((item) => item?._id !== value._id)
      );

      const newNotSelectedInfluencer = notSelectedCreators;
      newNotSelectedInfluencer.push(value); // add not selected influencer to newNotSelectedInfluencer array
      setNotSelectedCreators(newNotSelectedInfluencer);
    },
    [shortlistedInfluencers, notSelectedCreators]
  );
  const handleSelectManualCreator = useCallback(
    (value: NewCampaignInfluencerProfile) => {
      if (manuallyCreators?.find((item) => item === value?._id)) {
        setManuallyCreators(manuallyCreators.filter((i) => i !== value._id));
      } else {
        setManuallyCreators([...manuallyCreators, value._id]);
      }
    },
    [manuallyCreators]
  );

  const handlePayment = async () => {
    if (collabId === "sample") {
      setOpenSuccessPage(true);
      toast({
        title: "Campaign activated successfully",
        variant: "default",
      });
      generalState?.setLoading(false);
      return;
    }

    const additionalAmounts =
      collaborationCharges * selectedCreators?.length +
      usedCampaignAddOn * campaignCharges -
      (usedCollaborationCredits * collaborationCharges + usedAnchorsCredits);

    let Amount =
      previewData?.ExpectedSpendAmount +
      additionalAmounts +
      (previewData?.ExpectedSpendAmount + additionalAmounts) * 0.18;

    if (selectedPaymentFormat === "partial") {
      Amount =
        (previewData?.ExpectedSpendAmount + additionalAmounts) * 0.1 +
        (previewData?.ExpectedSpendAmount + additionalAmounts) * 0.1 * 0.18;
    }

    await handlePaymentClick({
      paymentInfo: "Create New Campaign",
      Amount,
      subject: "Create New Campaign",
      onSuccess: async (result) => {
        setPaymentProcessing(true);

        await brandState?.saveCollabData({
          collabId: collabId,
          step: 6,
          data: {
            Budget: {
              activationBill:
                selectedPaymentFormat === "partial" ? result?.order : null,
              makeLiveBill:
                selectedPaymentFormat === "full" ? result?.order : null,
              coupon,
            },
          },
          anchorsCredits: usedAnchorsCredits,
          collaborationsCredits: usedCollaborationCredits,
        });

        await brandState?.createCollabForInfluencer({
          brandId: authState?.loggedBrand?.BrandId,
          selectedCreators: selectedCreators,
          collabId: collabId,
        });

        setOpenSuccessPage(true);
        setPaymentProcessing(false);

        toast({
          title: "Campaign activated successfully",
          variant: "default",
        });
      },
      couponName: coupon,
      gst:
        selectedPaymentFormat === "partial"
          ? (previewData?.ExpectedSpendAmount + additionalAmounts) * 0.1 * 0.18
          : (previewData?.ExpectedSpendAmount + additionalAmounts) * 0.18,
      pg_charges: selectedPaymentMethod === "card" ? Amount * 0.023 : 0,
      collabId: collabId,
    });
  };
  const onCouponSubmit = () => {
    handleCouponCodeSubmit({
      coupon: coupon,
      amount: previewData?.ExpectedSpendAmount,
      onSuccess: (result) => {
        setAppliedCoup(true);
        setPreviewData((prev) => {
          return {
            ...prev,
            ExpectedSpendAmount: result?.netToPay,
          };
        });
      },
    });
  };

  // Debounced value - only updates after user stops typing for 300ms
  const debouncedSearchTerm = useDebounce(searchCreatorInput, 300);
  const handleSearchCreator = async (e) => {
    setSearchCreatorInput(e.target.value);
  };
  const handleSearchAfterDebounce = async () => {
    if (debouncedSearchTerm) {
      const result = await brandState?.getCreatorForCollabByName(
        debouncedSearchTerm
      );
      setManuallySearchCreators(result?.resolvedInfluencers);
    }
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      handleSearchAfterDebounce();
    }
  }, [debouncedSearchTerm]);

  return (
    <NewCampaignContext.Provider
      value={{
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        selectedCreators,
        setSelectedCreators,
        manuallyCreators,
        notSelectedCreators,
        setNotSelectedCreators,
        shortlistedInfluencers,
        setShortlistedInfluencers,
        selectedPurpose,
        setSelectedPurpose,
        selectedContentCategory,
        setSelectedContentCategory,
        selectedAudienceCategory,
        setSelectedAudienceCategory,
        selectedGender,
        setSelectedGender,
        selectedCountry,
        setSelectedCountry,
        selectedState,
        setSelectedState,
        selectedCities,
        setSelectedCities,
        selectedAudienceLocationIds,
        setSelectedAudienceLocationIds,
        selectedSeniority,
        setSelectedSeniority,
        openSelectPopup,
        setOpenSelectPopup,
        openReviewPopup,
        setOpenReviewPopup,
        openSuccessPage,
        setOpenSuccessPage,
        openDetailsPopup,
        setOpenDetailsPopup,
        currentStep,
        setCurrentStep,
        completedStep,
        setCompletedStep,
        isLoading,
        setIsLoading,
        refreshLoading,
        setRefreshLoading,
        isReviewDone,
        setIsReviewDone,
        formData,
        setFormData,
        previewData,
        setPreviewData,
        masterData,
        setMasterData,
        collaborationCharges,
        campaignCharges,
        collabFactors,
        currentPreviewList,
        setCurrentPreviewList,
        searchCreatorInput,
        setSearchCreatorInput,
        manuallySearchCreators,
        openCheckOutPopup,
        setOpenCheckOutPopup,
        manualSearch,
        setCollabFactors,
        setAllCredits,
        setCollabCharges,
        setCampaignCharges,
        stepValidations,
        collabId,
        setManuallyCreators,
        sampleCampaign,
        setSampleCampaign,

        //payment
        paymentProcessing,
        setPaymentProcessing,
        selectedPaymentFormat,
        setSelectedPaymentFormat,
        selectedPaymentMethod,
        setSelectedPaymentMethod,
        usedAnchorsCredits,
        usedCollaborationCredits,
        setUsedAnchorsCredits,
        setUsedCollaborationCredits,
        usedCampaignAddOn,
        setUsedCampaignAddOn,
        AllCredits,

        //filters
        openTryManualFilter,
        setOpenTryManualFilter,
        selectedEngageMentRate,
        setSelectedEngageMentRate,
        selectedSuperRoles,
        setSelectedSuperRoles,
        selectedUniqueBadge,
        setSelectedUniqueBadge,
        selectedAverageLikes,
        setSelectedAverageLikes,
        selectedYearsOfExperiance,
        setSelectedYearsOfExperiance,
        selectedCompanyTier,
        setSelectedCompanyTier,
        includedCollabCompanyNames,
        setIncludedCollabCompanyNames,
        excludedCollabCompanyNames,
        setExcludedCollabCompanyNames,

        //coupon
        allowCoupons,
        coupon,
        setCoupon,
        appliedCoup,
        setAppliedCoup,
        originalPriceBeforeCoupon,
        setOriginalPriceBeforeCoupon,
        onCouponSubmit,
        adminFeature,

        formValidation,
        handleSaveData,
        handleNext,
        handlePrevious,
        handleInputChange,
        handleFileChange,
        removeImage,
        saveProductImages,
        handleBudgetChange,
        handleDraftChange,
        handleSelectChange,
        handleSelectCreator,
        handleIgnoreCreator,
        handleSelectManualCreator,
        handlePayment,
        handleSearchCreator,
      }}
    >
      {children}
    </NewCampaignContext.Provider>
  );
};
